import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Carousel, createUseStyles } from '@Sage/hoi-poi-ui';

import FullModalBlank from 'components/FullModalBlank';

import styles from './styles';
const useStyles = createUseStyles(styles, 'CarouselFullModal');

const mapImagesToCarousel = (images = []) =>
    images
        .filter((image) => image?.strLink)
        .map((image) => ({
            original: image.strLink,
            thumbnail: image.strLink,
        }));

const CarouselFullModal = ({
    isOpen,
    className,
    modalOverlayClassName,
    headerClass,
    contentClass,
    contentLeftClass,
    contentCenterClass,
    contentRightClass,
    onAfterOpen,
    onRequestClose,
    withCloseIcon,
    shouldCloseOnEsc,
    shouldCloseOnOverlayClick,
    contentLeft,
    contentCenter,
    contentRight,
    imageSelected,
    updateImageSelected,
    images = [],
}) => {
    const classes = useStyles();
    const rootClassNames = classnames(classes.root, className);
    const overlayClassNames = classnames(classes.overlay, modalOverlayClassName);
    const contentClassNames = classnames(classes.content, contentClass);

    const carouselImages = useMemo(() => mapImagesToCarousel(images), [images]);
    const hasViewableImages = carouselImages.some((image) => image.original);

    if (!updateImageSelected || imageSelected < 0 || !hasViewableImages) return null;

    return (
        <FullModalBlank
            className={rootClassNames}
            overlayClassName={overlayClassNames}
            headerClassName={headerClass}
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            withCloseIcon={withCloseIcon}
            onRequestClose={onRequestClose}
            shouldCloseOnEsc={shouldCloseOnEsc}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
            contentLeftClassName={contentLeftClass}
            contentCenterClassName={contentCenterClass}
            contentRightClassName={contentRightClass}
            contentLeft={contentLeft}
            contentCenter={contentCenter}
            contentRight={contentRight}
        >
            <div className={contentClassNames}>
                <Carousel
                    className={classes.carousel}
                    images={carouselImages}
                    currentIndex={imageSelected}
                    onIndexChange={updateImageSelected}
                    embedded
                />
            </div>
        </FullModalBlank>
    );
};

CarouselFullModal.propTypes = {
    isOpen: PropTypes.bool,
    modalClassName: PropTypes.string,
    modalOverlayClassName: PropTypes.string,
    headerClass: PropTypes.string,
    contentClass: PropTypes.string,
    contentLeftClass: PropTypes.string,
    contentCenterClass: PropTypes.string,
    contentRightClass: PropTypes.string,
    onAfterOpen: PropTypes.func,
    onRequestClose: PropTypes.func,
    withCloseIcon: PropTypes.bool,
    shouldCloseOnEsc: PropTypes.bool,
    shouldCloseOnOverlayClick: PropTypes.bool,
    contentLeft: PropTypes.func,
    contentCenter: PropTypes.func,
    contentRight: PropTypes.func,
    images: PropTypes.array,
    imageSelected: PropTypes.number,
    updateImageSelected: PropTypes.func,
};

export default memo(CarouselFullModal);
